<app-help-closing-side-drawer [ngClass]="(canShowAiSupport$ | async) ? 'help-side-panel' : ''" [title]="title$ | async">
  <app-help-side-drawer-pre-title-actions>
    @if (helpCaseHistory.length > 1) {
      <button mat-icon-button color="primary" class="back-button" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
  </app-help-side-drawer-pre-title-actions>
  <app-help-side-drawer-content class="help-side-panel-content">
    @if (canShowAiSupport$ | async) {
      <div class="ai-support-container">
        <inbox-ai-support-banner (chatWithAiButtonClicked)="chatWithAiButtonClicked()"> </inbox-ai-support-banner>
      </div>
    }
    <div class="help-selection">
      @if ((canShowAiSupport$ | async) === false) {
        <div class="header-container">
          @if (displaySearch$ | async) {
            <glxy-form-field>
              <input
                matInput
                placeholder="{{ 'HELP_CENTER.SEARCH.INPUT' | translate }}"
                [formControl]="searchBar"
                (keyup.enter)="search()"
                autocomplete="off"
              />
              <mat-icon matSuffix>search</mat-icon>
            </glxy-form-field>
          } @else {
            <div class="search">
              {{ helpHeader | translate }}
            </div>
          }
        </div>
      }
      @if (currentPageId === 'search') {
        @if (articles.length === 0 && !isSearching) {
          <div class="result--none">
            <mat-icon class="results--none-icon">search_off</mat-icon>
            <div class="result--none-warning">
              {{ 'HELP_CENTER.SEARCH.NO_RESULTS.TITLE' | translate }}
            </div>
            {{ 'HELP_CENTER.SEARCH.NO_RESULTS.DESCRIPTION' | translate }}
            <span class="link" (click)="handleHelpCaseClick('contactUs')">
              {{ 'HELP_CENTER.SEARCH.NO_RESULTS.CONTACT_US' | translate }}
            </span>
          </div>
        } @else if (isSearching) {
          <div class="help-center-loading">
            <glxy-loading-spinner
              [size]="'default'"
              [fullWidth]="true"
              [fullHeight]="false"
              [inline]="false"
            ></glxy-loading-spinner>
          </div>
        }

        @for (article of articles; track article.title; let i = $index; let len = $count) {
          <app-help-search-card [article]="article"></app-help-search-card>
          @if (i !== len - 1) {
            <mat-divider class="result--divider"></mat-divider>
          } @else {
            @if (showLoadMore) {
              <div class="hc-load-more">
                <button mat-button color="primary" (click)="loadMoreClicked()">
                  {{ 'COMMON.ACTION_LABELS.LOAD_MORE' | translate }}
                </button>
              </div>
            }
            <div class="result--end">
              {{ 'HELP_CENTER.SEARCH.RESULTS.DESCRIPTION' | translate }}
              <span class="link" (click)="handleHelpCaseClick('contactUs')">
                {{ 'HELP_CENTER.SEARCH.RESULTS.CONTACT_US' | translate }}
              </span>
            </div>
          }
        }
      } @else {
        <div class="help-cards-container">
          <div
            [ngClass]="
              (canShowAiSupport$ | async)
                ? 'help-cards_inner-container no-width-container'
                : 'help-cards_inner-container'
            "
          >
            @if (helpCases$ | async) {
              @for (helpCase of helpCases$ | async; track helpCase.id) {
                <ng-container *ngTemplateOutlet="helpCaseCard; context: { helpCase: helpCase }"></ng-container>
              }
            } @else {
              <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
            }
          </div>
        </div>
      }
    </div>
  </app-help-side-drawer-content>
</app-help-closing-side-drawer>

<ng-template #helpCaseCard let-helpCase="helpCase">
  <app-help-case-card
    [hideStyle]="canShowAiSupport$ | async"
    [helpCase]="helpCase"
    [hasMeetingUrl]="bookMeetingUrl$ | async"
    (click)="handleHelpCaseClick(helpCase.id)"
  ></app-help-case-card>
</ng-template>
